<template>
  <div>
    <p class="text-14 text-gray-600 m-b-xs">Removes all of {{ coach.first_name }}'s open slots from a date forward, across every repeating time. Booked and invited lessons are never touched.</p>
    <label for="pl-close-after" class="text-14 m-b-none">Close slots on or after</label>
    <input id="pl-close-after" v-model="closeAfter" name="close_after" type="date" class="form-control m-b-xs" data-cy="close-after-date">
    <p v-if="closePreviewLoading" class="text-14 text-gray-500 m-b-xs"><i class="fa-solid fa-spinner fa-spin"></i> Counting open slots...</p>
    <template v-else-if="closePreviewCount !== null">
      <p v-if="closePreviewCount === 0" class="text-14 text-gray-600 m-b-xs" data-cy="close-slots-none">No open slots on or after that date.</p>
      <div v-else data-cy="close-slots-confirm">
        <ladda-button @lbClicked="closeSlots" el-class="btn-danger w-full" :loading="closing">
          Close {{ closePreviewCount }} open {{ closePreviewCount === 1 ? 'slot' : 'slots' }}
        </ladda-button>
      </div>
    </template>
    <div v-show="error" class="m-t-sm">
      <small><span class="text-danger">{{ errorMessage }}</span></small>
    </div>
  </div>
</template>

<script>
import LaddaButton from '../../shared/ladda_button.vue';
import { errorableMix } from './mixins/errorable_mix';

// Bulk close: the escape hatch for "I created recurring slots way too far into
// the future". Cuts across every repeat chain (unlike the per-slot recurring
// delete, which is chain-scoped); open slots only, booked lessons untouched.
// Extracted from the agenda sidebar so the coach home can offer it too.
export default {
  name: 'close-open-slots',
  components: { LaddaButton },
  mixins: [errorableMix],
  props: {
    coach: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      closeAfter: '',
      closePreviewCount: null,
      closePreviewLoading: false,
      closing: false,
    };
  },
  watch: {
    closeAfter(newDate) {
      this.closePreviewCount = null;
      if (newDate) {
        this.fetchClosePreview(newDate);
      } else {
        this.closePreviewLoading = false;
      }
    },
  },
  methods: {
    fetchClosePreview(afterDate) {
      const vm = this;
      vm.closePreviewLoading = true;
      const url = vm.$apiService.deletePrivateLessonSlotsUrl(vm.coach.id, afterDate, true);
      // Responses for a date the admin has already changed are stale — only
      // the request matching the current closeAfter may touch state
      axios.delete(url)
        .then((response) => {
          if (afterDate !== vm.closeAfter) {
            return;
          }
          vm.closePreviewCount = response.data.count;
          vm.closePreviewLoading = false;
        })
        .catch((error) => {
          if (afterDate !== vm.closeAfter) {
            return;
          }
          vm.closePreviewLoading = false;
          vm.errorMessage = vm.parseErrorResponse(error);
          vm.error = true;
        });
    },
    closeSlots() {
      const vm = this;
      if (vm.closing) {
        return;
      }
      vm.closing = true;
      const url = vm.$apiService.deletePrivateLessonSlotsUrl(vm.coach.id, vm.closeAfter);
      axios.delete(url)
        .then((response) => {
          vm.closing = false;
          const { count } = response.data;
          vm.$notificationManager.emit('show-toast', `${count} open ${count === 1 ? 'slot' : 'slots'} closed`, true);
          vm.closeAfter = '';
          vm.closePreviewCount = null;
          vm.$emit('closed');
        })
        .catch((error) => {
          vm.closing = false;
          vm.errorMessage = vm.parseErrorResponse(error);
          vm.error = true;
        });
    },
  },
};
</script>
